var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0001 5.9375C13.4025 5.9375 12.1073 7.1967 12.1073 8.75C12.1073 10.3033 13.4025 11.5625 15.0001 11.5625C16.5978 11.5625 17.893 10.3033 17.893 8.75C17.893 7.1967 16.5978 5.9375 15.0001 5.9375ZM10.1787 8.75C10.1787 6.16117 12.3373 4.0625 15.0001 4.0625C17.6629 4.0625 19.8216 6.16117 19.8216 8.75C19.8216 11.3388 17.6629 13.4375 15.0001 13.4375C12.3373 13.4375 10.1787 11.3388 10.1787 8.75Z",
    fill: "#1E1542"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4284 17.1875C10.1228 17.1875 8.24986 19.0084 8.24986 21.25V22.5C8.24986 23.3635 8.96885 24.0625 9.857 24.0625H20.1427C21.0309 24.0625 21.7499 23.3635 21.7499 22.5V21.25C21.7499 19.0084 19.8769 17.1875 17.5713 17.1875H12.4284ZM6.32129 21.25C6.32129 17.9729 9.05766 15.3125 12.4284 15.3125H17.5713C20.9421 15.3125 23.6784 17.9729 23.6784 21.25V22.5C23.6784 24.399 22.096 25.9375 20.1427 25.9375H9.857C7.90373 25.9375 6.32129 24.399 6.32129 22.5V21.25Z",
    fill: "#1E1542"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 24,
    r: 4.5,
    fill: "#20AD09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatarIcon.53ae73dd56df1a276bfd00c5d26e7393.svg";
export { ForwardRef as ReactComponent };